import styled from 'styled-components';
import {Color} from '../../../../../../../common/utils/color-util';

export const LiveCasinoNavbarDefaultBox = styled.div<{stickOffset: number;}>`
    background: ${props => props.theme.colors.background};
    border-bottom: 1px solid ${props => props.theme.colors.boxBorderDark};
    position: sticky;
    top: ${({stickOffset}) => (stickOffset - 1) + "px"};
    z-index: 100;

    padding-top: 1rem;
    padding-bottom: 1rem;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
    &.sticky-navbar {
        @supports (backdrop-filter: blur(6px)) {
            background-color: ${props => Color.fromHex(props.theme.colors.backgroundDark, 0.5).hexa()};
            backdrop-filter: blur(10px);
        }
    }
`;
